// extracted by mini-css-extract-plugin
module.exports = {"forumLayout":"styles-module__forumLayout___3nWEj"};